<template>
  <el-row :gutter="15">
    <el-col :span="showMonthly ? 12 : 24" class="select-billing">
      <el-card v-bind:class="{ inactive: reserved }" :shadow="reserved ? 'hover' : 'always'">
        <el-button slot="header" type="text" @click="$emit('update:reserved', false)">
          <span>Hourly</span>
        </el-button>
        <el-button
          v-if="permission('owner') || permission('admin')"
          type="text"
          @click="$emit('update:reserved', false)"
        >
          <div class="description">{{ $root.currency.symbol }}{{ hour.replace(/([0-9]{3})$/, '.$1') }} / hour</div>
        </el-button>
        <div class="description manager" v-else>to easily scale resources</div>
      </el-card>
    </el-col>

    <el-col v-if="showMonthly" :span="12" class="select-billing">
      <el-card v-bind:class="{ inactive: !reserved }" :shadow="!reserved ? 'hover' : 'always'">
        <el-button slot="header" type="text" @click="$emit('update:reserved', true)">
          <span>Monthly</span>
        </el-button>
        <el-button
          v-if="permission('owner') || permission('admin')"
          type="text"
          @click="$emit('update:reserved', true)"
        >
          <div class="description">{{ $root.currency.symbol }}{{ month.replace(/([0-9]{2})$/, '') }} / month</div>
        </el-button>
        <div class="description manager" v-else>for long-term projects, billed monthly</div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    reserved: Boolean,
    storageSize: {
      type: Number,
      default: 10
    },
    price: {
      type: Object,
      default: () => ({
        hour: '',
        month: ''
      })
    },
    showMonthly: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hour () {
      const hour = parseInt(this.price.hour)
      return Math.ceil(hour + (this.storageFee(this.storageSize) * 10 / 744)).toString().padStart(4, 0)
    },
    month () {
      const month = parseInt(this.price.month)
      return (month + this.storageFee(this.storageSize)).toString().padStart(3, 0)
    },
    ...mapGetters(['permission'])
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .select-billing {
    .el-card {
      border: 1px solid $--color-primary !important;

      .el-button {
        width: 100%;
        display: block;
        margin: 0 auto;
        padding: 0;
        font-weight: 700 !important;
      }
      .description {
        font-weight: 300;
        line-height: 1.8rem;

        &.manager {
          color: $--color-primary;
        }
      }

      &.disable {
        .el-button {
          color: #faca7c;
        }
      }

      &.inactive {
        background-color: #f5f7fa;
        border-color: #f5f7fa !important;

        .el-button {
          color: #777;
          font-weight: 400 !important;
        }
        .light {
          opacity: 0.5;
        }
        .description.manager {
          color: #777;
        }
      }
    }
  }
</style>

<style lang="scss">
  .select-billing {
    margin-bottom: 15px;
    text-align: center;

    .el-card__body {
      padding: 10px 0;
    }
  }
</style>
